import { api, type GroceryMatchView, type Item } from "../api";
import { showSheet } from "./modal";
import { msg } from "../messages";

function createActionButton(
    label: string,
    className: string,
    onClick: () => void | Promise<void>,
): HTMLButtonElement {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = className;
    btn.textContent = label;
    btn.addEventListener("click", () => {
        void onClick();
    });
    return btn;
}

function showGroceryLinkPrompt(item: Item, match: GroceryMatchView): Promise<void> {
    return new Promise((resolve) => {
        const content = document.createElement("div");
        content.className = "grocery-link-prompt";

        const message = document.createElement("p");
        message.className = "grocery-link-prompt-message";
        const matchKind =
            match.mode === "manual"
                ? msg("grocery-link/match-kind-manual")
                : msg("grocery-link/match-kind-auto");
        message.textContent = msg("grocery-link/similar-prompt", {
            itemName: item.name,
            matchName: match.name,
            matchKind,
        });
        content.appendChild(message);

        const actions = document.createElement("div");
        actions.className = "grocery-link-prompt-actions";

        let settled = false;
        const settle = () => {
            if (settled) return;
            settled = true;
            resolve();
        };

        const close = showSheet("Grocery list match", content, settle, { dismissible: true });

        const runAction = async (action: () => Promise<void>) => {
            await action();
            close();
            settle();
        };

        if (match.mode === "manual") {
            actions.appendChild(
                createActionButton("Remove from list", "btn btn-danger btn-block", () =>
                    runAction(async () => {
                        try {
                            await api.grocery.delete(match.id);
                        } catch {}
                    }),
                ),
            );
            actions.appendChild(
                createActionButton("Link as auto-restock", "btn btn-primary btn-block", () =>
                    runAction(async () => {
                        try {
                            await api.grocery.link(match.id, item.id);
                        } catch {}
                    }),
                ),
            );
        } else {
            actions.appendChild(
                createActionButton("Link to this item", "btn btn-primary btn-block", () =>
                    runAction(async () => {
                        try {
                            await api.grocery.link(match.id, item.id);
                        } catch {}
                    }),
                ),
            );
        }

        actions.appendChild(
            createActionButton("Not now", "btn btn-secondary btn-block", () => {
                close();
                settle();
            }),
        );

        content.appendChild(actions);
    });
}

export async function promptGroceryLinksForItem(item: Item): Promise<void> {
    let matches: GroceryMatchView[] = [];
    try {
        matches = await api.grocery.findMatches(item.id);
    } catch {
        return;
    }

    for (const match of matches) {
        await showGroceryLinkPrompt(item, match);
    }

    if (matches.length > 0) {
        window.dispatchEvent(new CustomEvent("pantry-sync"));
    }
}
